import { render, staticRenderFns } from "./RegistersHeader.vue?vue&type=template&id=7a694b0e&"
import script from "./RegistersHeader.vue?vue&type=script&lang=js&"
export * from "./RegistersHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports